import { fetchEventSource } from '@microsoft/fetch-event-source';
import { attempt } from 'es-toolkit';
import { OperationName, OperationStatus } from '../../models';
import { FetchContext } from '../fetch-context';

export type OperationStatusHandler = (status: OperationStatus) => void;

export const streamOperationStatus: (
  fetchContext: FetchContext,
  operationName: OperationName,
  onStatus: OperationStatusHandler,
  accessToken?: string,
  signal?: AbortSignal,
) => Promise<void> = async (fetchContext, operationName, onStatus, accessToken, signal) => {
  const params = new URLSearchParams({ operationName });

  await fetchEventSource(`${fetchContext.baseUrl}/api/admin/operations/stream?${params}`, {
    method: 'GET',
    openWhenHidden: true,
    signal,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'text/event-stream',
    },
    onmessage: (event) => {
      if (!event.data) {
        return;
      }

      const [error, status] = attempt(() => JSON.parse(event.data) as OperationStatus);
      if (!error && status) {
        onStatus(status);
      }
    },
  });
};
